<template>
  <v-card
    class="v-card--wizard"
    elevation="12"
    max-width="800"
  >
    <div class="text-center display-2 grey--text font-weight-light mb-6">
      Внесите всю необходимую информацию.
    </div>

    <!--<v-tabs
      ref="tabs"
      v-model="internalValue"
      background-color="green lighten-5"
      class="pa-3"
      color="white"
      grow
      slider-size=" "
    >
      <v-tabs-slider
        class="elevation-6 mt-1"
        color="success"
      />

      <v-tab
        v-for="(item, i) in items"
        :key="i"
        :ripple="false"
        :disabled="!availableSteps.includes(i)"
      >
        {{ item }}
      </v-tab>
    </v-tabs>-->

    <div class="my-6" />

    <v-card-text>
      <v-tabs-items v-model="internalValue">
        <slot />
      </v-tabs-items>
    </v-card-text>

    <v-card-actions>
      <v-btn
        :disabled="internalValue === 0 || load"
        class="white--text"
        color="grey darken-2"
        min-width="125"
        @click="$emit('click:prev')"
      >
        Назад
      </v-btn>

      <v-spacer />

      <v-btn
        :disabled="!availableSteps.includes(internalValue + 1) || load"
        color="success"
        min-width="100"
        @click="$emit('click:next')"
      >
        {{ internalValue === items.length - 1 ? 'Завершить' : 'Дальше' }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  // Mixins
  import Proxyable from 'vuetify/lib/mixins/proxyable'

  export default {
    name: 'BaseMaterialWizard',

    mixins: [Proxyable],

    props: {
      availableSteps: {
        type: Array,
        default: () => ([]),
      },
      items: {
        type: Array,
        default: () => ([]),
      },
      load: {
        type: Boolean,
        default: () => false,
      },
    },
  }
</script>

<style lang="sass">
  .v-card--wizard
    overflow: visible

    .v-tabs-bar
      height: 56px
      padding: 0 8px

    .v-slide-group__wrapper
      overflow: visible

    .v-tabs-slider
      border-radius: 4px

    .v-slide-group__wrapper
      contain: initial
</style>
